<template>
  <div class="row" style="width: 98%;margin: auto;">
    <div class="col-md-12 col-12">
      <div>
        <img style="width: 100%;height: 230px;border-radius:30px;object-fit: cover" class="w-100"
             src="https://i.pinimg.com/originals/5f/d3/cc/5fd3cc9586103ac732457afa9568b68a.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slide"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Slide.vue